var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { showErrorToast, showSuccessToast } from '@ui';
import I18n from '@utils/i18n';
import api from '@utils/axios';
import { reportEmailPath } from '@routes';
import SendReportEmailModalView from './SendReportEmailModalView';
import useReportEmailDraft from './useReportEmailDraft';
export default function SendReportEmailModal({ reportId, onClose, onSent }) {
    const { draft, loading, failed } = useReportEmailDraft(reportId);
    const [sending, setSending] = useState(false);
    const send = (_a) => __awaiter(this, [_a], void 0, function* ({ sendToEmail, subject, body, bccMe, bccMultipleParticipants }) {
        var _b, _c;
        if (reportId === null)
            return;
        setSending(true);
        try {
            /* eslint-disable @typescript-eslint/naming-convention */
            const { data } = yield api.post(reportEmailPath(reportId), {
                send_to_email: sendToEmail,
                subject,
                body,
                bcc_me: bccMe,
                bcc_multiple_participants: bccMultipleParticipants
            });
            /* eslint-enable @typescript-eslint/naming-convention */
            showSuccessToast(data.message);
            onSent === null || onSent === void 0 ? void 0 : onSent();
            onClose();
        }
        catch (error) {
            const message = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message;
            showErrorToast(message !== null && message !== void 0 ? message : String(I18n.t('generic.errors.request_error')));
        }
        finally {
            setSending(false);
        }
    });
    return (React.createElement(SendReportEmailModalView, { draft: draft, loading: loading, loadFailed: failed, sending: sending, isOpen: reportId !== null, onClose: onClose, onSubmit: (payload) => {
            void send(payload);
        } }));
}
